import CustomConfirm from 'components/common/CustomConfirm'
import { Dialog } from 'quasar'
// import SignUpConfirmDialog from 'components/common/SignUpConfirm'
// import CustomConfirmCoupon from 'components/common/CustomConfirmCoupon'
import { useShowCaseStore } from 'src/stores/showcase'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

export const signUpConfirm = function () {
  return Dialog.create({
    // component: SignUpConfirmDialog,
    // parent: this,
    component: defineAsyncComponent(() =>
      import('src/components/common/SignUpConfirm.vue')
    ),
  })
}

export default ({ app, store }) => {
  app.mixin({
    data() {
      return {
        showcaseStore: useShowCaseStore(),
      }
    },
    computed: {
      ...mapState(useShowCaseStore, ['getDialogProperties', 'getDialogState']),
    },
    methods: {
      changeDialogState({
        dialog = '',
        val = false,
        parentDialog = '',
        properties = null,
        refresh = false,
      }) {
        if (dialog) {
          this.showcaseStore.updateDialogState({
            dialog,
            val,
            parentDialog,
          })

          if (properties)
            this.showcaseStore.setDialogProperties({
              dialog,
              properties,
              refresh,
            })
        }
      },
      deleteDialogProperties(dialog = '') {
        if (dialog) this.showcaseStore.deleteDialogProperties(dialog)
      },
      ftxConfirm(
        title,
        description,
        cancelBtnLabel,
        confirmBtnLabel,
        closeBtn = null,
        outsideClickCloseDisable = null
      ) {
        let props = { text: title }
        if (description) props['description'] = description
        if (cancelBtnLabel) props['cancelBtnLabel'] = cancelBtnLabel
        if (confirmBtnLabel) props['confirmBtnLabel'] = confirmBtnLabel
        if (closeBtn !== null) props['closeBtn'] = closeBtn
        if (outsideClickCloseDisable !== null)
          props['outsideClickCloseDisable'] = outsideClickCloseDisable
        return this.$q.dialog({
          component: CustomConfirm,
          parent: this,
          componentProps: props,
        })
      },
      ftxConfirmCoupon(
        title,
        description,
        cancelBtnLabel,
        confirmBtnLabel,
        closeBtn = null,
        outsideClickCloseDisable = null,
        iconName,
        iconSize,
        isSVG = null,
        isIMG = null,
        cancelbtn = null,
        okbtn = null
      ) {
        let props = { text: title }
        if (description) props['description'] = description
        if (cancelBtnLabel) props['cancelBtnLabel'] = cancelBtnLabel
        if (confirmBtnLabel) props['confirmBtnLabel'] = confirmBtnLabel
        if (closeBtn !== null) props['closeBtn'] = closeBtn
        if (outsideClickCloseDisable !== null)
          props['outsideClickCloseDisable'] = outsideClickCloseDisable
        if (iconName) props['iconName'] = iconName
        if (iconSize) props['iconSize'] = iconSize
        if (isSVG !== null) props['isSVG'] = isSVG
        if (isIMG !== null) props['isIMG'] = isIMG
        if (cancelbtn !== null) props['cancelbtn'] = cancelbtn
        if (okbtn !== null) props['okbtn'] = okbtn

        return Dialog.create({
          // component: CustomConfirmCoupon,
          // parent: this,
          component: defineAsyncComponent(() =>
            import('src/components/common/CustomConfirmCoupon.vue')
          ),
          componentProps: props,
        })
      },
      accountClosedConfirm() {
        return Dialog.create({
          // component: AccountCloseConfirm,
          // parent: this,
          component: defineAsyncComponent(() =>
            import('src/components/common/AccountCloseConfirm.vue')
          ),
        })
      },
      signUpConfirm() {
        return Dialog.create({
          // component: SignUpConfirmDialog,
          // parent: this,
          component: defineAsyncComponent(() =>
            import('src/components/common/SignUpConfirm.vue')
          ),
        })
      },
    },
  })

  /* Vue.prototype['changeDialogState'] = changeDialogState
  Vue.prototype['deleteDialogProperties'] = deleteDialogProperties
  Vue.prototype['ftxConfirm'] = ftxConfirm
  Vue.prototype['ftxConfirmCoupon'] = ftxConfirmCoupon
  Vue.prototype['signUpConfirm'] = signUpConfirm
  Vue.prototype['accountClosedConfirm'] = accountClosedConfirm
  Vue.prototype['getDialogProperties'] =
    store.getters['showcase/getDialogProperties']
  Vue.prototype['getDialogState'] = store.getters['showcase/getDialogState'] */

  // Vue.mixin({
  //   computed: {
  //     ...mapGetters('showcase', ['getDialogProperties', 'getDialogState']),
  //   },
  //   methods: {
  //     changeDialogState,
  //     deleteDialogProperties,
  //     ftxConfirm,
  //     ftxConfirmCoupon,
  //     signUpConfirm,
  //     accountClosedConfirm,
  //   },
  // })
}
